import {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {faCalendarStar, faNewspaper, faTags} from '@fortawesome/pro-regular-svg-icons';

import {LangKeyType} from '../../../../provider/locale/translation/type';
import {CalendarPostStatusEnum} from '../../../../service/posts/posts-types';
import {
    CalendarModerationEnum,
    CalendarPublicationTypeEnum,
} from '../../../../service/publications/publications-calendar-type';

export const BADGE_COLOR_BY_CALENDAR_POST_STATUS: Record<CalendarPostStatusEnum, string> = {
    [CalendarPostStatusEnum.publishPlanned]: '#4581c5',
    [CalendarPostStatusEnum.deletePlanned]: '#dc6c59',
    [CalendarPostStatusEnum.published]: '#50b079',
    [CalendarPostStatusEnum.refreshPlanned]: '#fdad59',
};

export const TEXT_IN_YEAR_CARD_BY_POST_STATUS: Record<CalendarPostStatusEnum, LangKeyType> = {
    [CalendarPostStatusEnum.publishPlanned]: 'POSTS__CALENDAR_BADGE__YEAR_CARD__PUBLISH_PLANNED',
    [CalendarPostStatusEnum.deletePlanned]: 'POSTS__CALENDAR_BADGE__YEAR_CARD__DELETE_PLANNED',
    [CalendarPostStatusEnum.published]: 'POSTS__CALENDAR_BADGE__YEAR_CARD__SENT',
    [CalendarPostStatusEnum.refreshPlanned]: 'POSTS__CALENDAR_BADGE__YEAR_CARD__REFRESH_PLANNED',
};

// The badge colour already encodes the status, so the publication type is shown with an icon.
export const ICON_BY_CALENDAR_PUBLICATION_TYPE: Record<CalendarPublicationTypeEnum, IconDefinition> = {
    [CalendarPublicationTypeEnum.post]: faNewspaper,
    [CalendarPublicationTypeEnum.promotion]: faTags,
    [CalendarPublicationTypeEnum.event]: faCalendarStar,
};

export const TEXT_BY_CALENDAR_MODERATION: Record<CalendarModerationEnum, LangKeyType> = {
    [CalendarModerationEnum.onModeration]: 'POSTS__CALENDAR__MODERATION__ON_MODERATION',
    [CalendarModerationEnum.rejected]: 'POSTS__CALENDAR__MODERATION__REJECTED',
};
